import { isValidLocalPhoneNumber } from "utils/helpers/phone";
import * as yup from "yup";

const contactAdvisorValidation = (errors) =>
  yup.object().shape({
    lastname: yup.string().required(errors.REQUIRED),
    firstname: yup.string().required(errors.REQUIRED),
    phonePrefix: yup.string().nullable(),
    phone: yup
      .string()
      .nullable()
      .test("phone", errors.INVALID_PHONE, function (value) {
        if (!value) return true;
        const normalized = String(value).replace(/\s+/g, "");
        return isValidLocalPhoneNumber(normalized, this.parent.phonePrefix);
      }),
    email: yup.string().required(errors.REQUIRED).email(errors.INVALID_VALUE),
    memberNumber: yup.string().required(errors.REQUIRED),
    acceptEmailSms: yup.boolean(),
    acceptPhone: yup.boolean(),
  });

export default contactAdvisorValidation;
